module.exports = __webpack_public_path__ + "static/media/logo_v1.ea1f1f7a.png";